export const NEW_USER_REQUIREMENTS_VIEW_CONTEXT_INITIAL_VALUE = {
    isMoreDetailsModalOpen: false,
    isProcessAlreadyStartedModalOpen: false,
    handleToggleMoreDetailsModal: () => {},
    handleToggleProcessAlreadyStartedModal: () => {},
    onClickStartProcess: () => {},
};
